import Poi from '@/components/sl-amap/components/amap-poi-live'
import { wgs2gcj } from '@/util/map/proj'
import Event from '@/util/proto/event'
import request from '@/util/request'

class LiveLayer extends Event{
  constructor(map , moveMode = true) {
    super()
    this.map = map
    this.visible = true
    this.lastFocus = null
    this.poiTpl = '<div class="sl-amap-poi-span sl-amap-poi-span--{mixState}" data-id="{id}" title="{id}"><div class="sl-amap-poi-span__cover" style="background-image:url({logo});"></div><div class="sl-amap-poi-span__content">{companyName}<br />{label}<i /></div></div>'
    this.poiManager = new Poi(map, {
      poiTpl: this.poiTpl,
      size: [85, 42],
      offset: [-16, -37],
      moveMode:moveMode,
      handlers:{
        open:(data)=>{
          this.trigger('click' , data)
        }
      }
    })

    map.on('moveend', this.update)

    // map.on('zoomstart', this.beforeZoom)
    map.on('zoomend', this.update)
    map.on('resize', this.update)
  }

  setData(data) {
    this.poiManager.load(data.filter(i => (i.lng && i.lat)))
    data.forEach(i=>{
      let {id , mixState} = i
      let el = document.querySelector('.sl-amap-poi-span[data-id="'+id+'"]')
      if(el){
        let cls = el.className
        let focusCls = cls.indexOf('focus') >= 0 ? ' focus' : ''
        if(!cls.includes('sl-amap-poi-span--'+mixState)){
          el.className = 'sl-amap-poi-span sl-amap-poi-span--'+mixState+focusCls
        }
      }
    })
  }

  setTypeState(key , state){
    this.poiManager.setType(key , state)
  }

  hide() {
    this.visible = false
    this.poiManager.hide()
    // this.unwatch()
  }

  show() {
    this.visible = true
    this.poiManager.show()
    // this.watch()
  }

  clear(){
    this.poiManager.clear()
  }

  update(){
    //this.fetchCompany(this.poiManager.getBounds(true))
  }

  focus(id){
    if(this.lastFocus){
      let el = document.querySelector('.sl-amap-poi-span.focus')
      // 
      if( el ){
        el.className =  el.className.replace('focus','')
      }
    }

    if(id){
      let el = document.querySelector('.sl-amap-poi-span[data-id="'+id+'"]')
      if(el){
        el.className = el.className += ' focus'
        this.poiManager.focus(id)
      }
      
    }

    this.lastFocus = id
  }

  destroy(){
    this.poiManager.destroy()
  }
}


export default LiveLayer
